<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <Alert banner closable>搜索支持全局搜索，多条件搜索时请使用“|”作为条件分隔符</Alert>
          <div class="search-con search-con-top">
            <Row>
              <Upload action="" :before-upload="handleBeforeUpload" accept=".xls, .xlsx">
                <Button icon="ios-cloud-upload-outline" :loading="uploadLoading" @click="handleUploadFile">导入</Button>
              </Upload>
            </Row>
            <Row>
              <div class="ivu-upload-list-file" v-if="file !== null">
                <Icon type="ios-stats"></Icon>
                {{ file.name }}
                <Icon v-show="showRemoveFile" type="ios-close" class="ivu-upload-list-remove"
                      @click.native="handleRemove()"></Icon>
              </div>
            </Row>
            <Row>
              <transition name="fade">
                <Progress v-if="showProgress" :percent="progressPercent" :stroke-width="2">
                  <div v-if="progressPercent == 100">
                    <Icon type="ios-checkmark-circle"></Icon>
                    <span>成功</span>
                  </div>
                </Progress>

              </transition>
              <el-progress :text-inside="true" :stroke-width="24" :percentage="inprogress" v-if="progressPercent == 100" status="success" style="margin-bottom: 10px;margin-top: 10px"></el-progress>
              <Button v-if="progressPercent == 100" type="error" class="search-btn" :loading="uploadLoading"
                      @click="handlerimport">确认导入
              </Button>
              <Button v-if="rules.import_admin" type="info" class="search-btn" :loading="uploadLoading"
                      @click="handlerimportold">确认导入
              </Button>
              <div v-if="showre" class="ivu-upload-list-file">
                {{ showretxt }}
              </div>
            </Row>
            <Input class="search-input" v-model="searchVal.key" style="padding:5px;" placeholder="输入关键字全局搜索"
                   @on-enter="searchinput"/>
            <slot name="new_btn">
              <Button type="primary" @click="editModal('', 'post', '新增')" class="search-btn">新增</Button>
            </slot>
            <Button type="error" class="search-btn" @click="handlerDelete">批量删除</Button>
            <el-divider content-position="left">高级搜索</el-divider>
            <el-row :gutter="10" type="flex" style="margin-left: 20px;">

              <el-col :span="5">年龄：
                <el-input-number v-model="searchVal.ages" style="width: 100px;" :min="16" :max="99" controls-position="right"></el-input-number>
                <el-input-number v-model="searchVal.agee" style="width: 100px;" :min="16" :max="99" controls-position="right"></el-input-number>
              </el-col>
              <el-col :span="5">人员类别：  <el-select
              v-model="searchVal.type"
              clearable
              filterable
              default-first-option
              placeholder="请选择人员类型">
              <el-option
                v-for="item in typeList"
                :key="item.value"
                :label="item.meaning"
                :value="item.value">
              </el-option>
            </el-select></el-col>
              <el-col :span="5">困难类型：  <el-select
                clearable
                v-model="searchVal.difftype"
                filterable
                default-first-option
                placeholder="请选择人员类型">
                <el-option
                  v-for="item in difftypeList"
                  :key="item.value"
                  :label="item.meaning"
                  :value="item.value">
                </el-option>
              </el-select></el-col>
              <el-col :span="5">就业状态：  <el-select
                clearable
                v-model="searchVal.employmenttype"
                filterable
                default-first-option
                placeholder="请选择人员类型">
                <el-option
                  v-for="item in employmenttypeList"
                  :key="item.value"
                  :label="item.meaning"
                  :value="item.value">
                </el-option>
              </el-select></el-col>

              <el-button type="primary" icon="el-icon-search" @click="searchinput">搜索</el-button>

            </el-row>
          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>
          <Table v-loading.fullscreen.lock="fullscreenLoading" height="670" size="small" ref="selection" border
                 :columns="columns" :data="tableData"
                 @on-selection-change="handleSelectChange"></Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>
          <Modal v-model="modalMap.modalVisible" :title="modalMap.modalTitle" :loading=true :footer-hide=true
                 :mask-closable=false>
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
              <FormItem
                label="个人编号"
                prop="perno"
              >
                <Input
                  v-model="formValidate.perno"
                  placeholder="请输入个人编号"
                ></Input>
              </FormItem>
              <FormItem
                label="姓名"
                prop="pname"
              >
                <Input
                  v-model="formValidate.pname"
                  placeholder="请输入姓名"
                ></Input>
              </FormItem>
              <FormItem
                label="性别"
                prop="sex"
              >
                <el-select
                  v-model="formValidate.sex"
                  filterable
                  default-first-option
                  placeholder="请选择性别">
                  <el-option
                    v-for="item in sexList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem
                label="身份证号"
                prop="idcard"
              >
                <Input
                  v-model="formValidate.idcard"
                  placeholder="请输入身份证号"
                ></Input>
              </FormItem>
              <FormItem
                label="文化程度"
                prop="pedu"
              >
                <el-select
                  v-model="formValidate.pedu"
                  filterable
                  default-first-option
                  placeholder="请选择文化程度">
                  <el-option
                    v-for="item in peduList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem
                label="联系电话"
                prop="phone"
              >
                <Input
                  v-model="formValidate.phone"
                  placeholder="请输入联系电话"
                ></Input>
              </FormItem>
              <FormItem
                label="户籍区划"
                prop="account"
              >
                <Input
                  v-model="formValidate.account"
                  placeholder="请输入户籍区划"
                ></Input>
              </FormItem>
              <FormItem
                label="困难类型"
                prop="difftype"
                v-if="formValidate.type == '2'"
              >
                <el-select
                  v-model="formValidate.difftype"
                  filterable
                  default-first-option
                  placeholder="请选择困难类型">
                  <el-option
                    v-for="item in difftypeList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem
                label="月均收入"
                prop="mincome"
                v-if="formValidate.type == '2'"
              >
                <Input
                  v-model="formValidate.mincome"
                  placeholder="请输入月均收入"
                ></Input>
              </FormItem>
              <FormItem
                label="人员类型"
                prop="type"
              >
                <el-select
                  v-model="formValidate.type"
                  filterable
                  default-first-option
                  placeholder="请选择人员类型">
                  <el-option
                    v-for="item in typeList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem
                label="户口性质"
                prop="accounttype"
                v-if="formValidate.type == '1'"
              >
                <el-select
                  v-model="formValidate.accounttype"
                  filterable
                  default-first-option
                  placeholder="请选择户口性质">
                  <el-option
                    v-for="item in accounttypeList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem
                label="就业创业证号"
                prop="cardno"
                v-if="formValidate.type == '1'"
              >
                <Input
                  v-model="formValidate.cardno"
                  placeholder="请输入就业创业证号"
                ></Input>
              </FormItem>
              <FormItem
                label="登记失业地类型"
                prop="untype"
                v-if="formValidate.type == '1'"
              >
                <el-select
                  v-model="formValidate.untype"
                  filterable
                  default-first-option
                  placeholder="请选择登记失业地类型">
                  <el-option
                    v-for="item in untypeList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem
                label="失业时间"
                prop="untime"
                v-if="formValidate.type == '1'"
              >
                <DatePicker type="date" editable v-model="formValidate.untime" format="yyyy-MM-dd"
                            placement="bottom-end" placeholder="请选择失业时间"></DatePicker>
              </FormItem>
              <FormItem
                label="失业登记时间"
                prop="unregtime"
                v-if="formValidate.type == '1'"
              >
                <DatePicker type="date" editable v-model="formValidate.unregtime" format="yyyy-MM-dd"
                            placement="bottom-end" placeholder="请选择失业登记时间"></DatePicker>
              </FormItem>
              <FormItem
                label="失业登记原因"
                prop="unresult"
                v-if="formValidate.type == '1'"
              >
                <Input
                  v-model="formValidate.unresult"
                  placeholder="请输入失业登记原因"
                ></Input>
              </FormItem>
              <FormItem
                label="户籍地址"
                prop="accaddress"
                v-if="formValidate.type == '1'"
              >
                <Input
                  v-model="formValidate.accaddress"
                  placeholder="请输入户籍地址"
                ></Input>
              </FormItem>
              <FormItem
                label="居住地址"
                prop="nowaddress"
                v-if="formValidate.type == '1'"
              >
                <Input
                  v-model="formValidate.nowaddress"
                  placeholder="请输入居住地址"
                ></Input>
              </FormItem>
              <FormItem
                label="是否申领失业保险金"
                prop="getinsurance"
                v-if="formValidate.type == '1'"
              >
                <el-select
                  v-model="formValidate.getinsurance"
                  filterable
                  default-first-option
                  placeholder="请选择是否申领失业保险金">
                  <el-option
                    v-for="item in getinsuranceList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem
                label="培训愿望1"
                prop="train1"
                v-if="formValidate.type == '1'"
              >
                <Input
                  v-model="formValidate.train1"
                  placeholder="请输入培训愿望1"
                ></Input>
              </FormItem>
              <FormItem
                label="培训愿望2"
                prop="train2"
                v-if="formValidate.type == '1'"
              >
                <Input
                  v-model="formValidate.train2"
                  placeholder="请输入培训愿望2"
                ></Input>
              </FormItem>
              <FormItem
                label="培训愿望3"
                prop="train3"
                v-if="formValidate.type == '1'"
              >
                <Input
                  v-model="formValidate.train3"
                  placeholder="请输入培训愿望3"
                ></Input>
              </FormItem>
              <FormItem
                label="状态"
                prop="state"
              >
                <el-select
                  v-model="formValidate.state"
                  filterable
                  default-first-option
                  placeholder="请选择状态">
                  <el-option
                    v-for="item in stateList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem>
                <Button
                  type="primary"
                  @click="handleSubmit('formValidate')"
                >提交
                </Button>
                <Button
                  @click="handleReset('formValidate')"
                  style="margin-left: 8px"
                >重置
                </Button>
              </FormItem>
            </Form>
          </Modal>
          <Modal v-model="onetoneVisble" :title="onetoneTitle" :loading=true :footer-hide=true
                 :width="900"
                 :mask-closable=false>
            <iframe
              :src="'https://ljtc.tcrc.com.cn/webroot/decision/view/report?viewlet=yryd.cpt&ref_t=design&op=view&id='+onerowid"
              id="mobsf" width="100%" height="600" scrolling="no" frameborder="0"></iframe>

          </Modal>
        </Card>
      </i-col>
    </Row>
  </div>
</template>
<script>

import {
  getAssistpersonlist, importexceldata,
  operationAssistperson
} from '@/api/assist/assistperson.js'
import {getsysparameterList} from '@/api/system/sys_parameter'
import excel from '@/libs/excel'
import {mapState} from 'vuex'

let moment = require('moment')
export default {
  data () {
    return {
      message: '',
      ws: null,
      onetoneVisble:false,
      onerowid:0,
      onetoneTitle:'一对一就业帮扶人员基本情况表',
      spinShow: false,
      fullscreenLoading: false,
      sexList: [],
      peduList: [],
      difftypeList: [],
      employmenttypeList: [],
      typeList: [],
      accounttypeList: [],
      untypeList: [],
      getinsuranceList: [],
      stateList: [],
      formValidate: {},
      searchVal: {
        key: '',
        ages: 16,
        agee: 60,
        type: '',
        difftype: '',
        employmenttype: ''
      },
      showProgress: false,
      progressPercent: 0,
      loadingProgress: 0,
      inprogress:0,
      file: null,
      showRemoveFile: false,
      uploadLoading: false,
      tableData: [],
      tableDatatmp: [],
      tableTitle: [],
      tableLoading: false,
      showre: false,
      showretxt: '',
      modalMap: {
        modalVisible: false,
        modalTitle: '新建'
      },
      tableSelectIdList: [],
      editModalData: '',
      pageNum: 1, // 当前页码
      pageTotal: 0, // 数据总数
      pageSize: 15, // 每页条数

      ruleValidate: {
        perno: [
          {
            required: true,
            message: '个人编号不能为空',
            trigger: 'blur'
          }
        ],
        pname: [
          {
            required: true,
            message: '姓名不能为空',
            trigger: 'blur'
          }
        ],
        sex: [
          {
            required: true,
            message: '请选择性别',
            trigger: 'change'
          }
        ],
        idcard: [
          {
            required: true,
            message: '身份证号不能为空',
            trigger: 'blur'
          }
        ],
        pedu: [
          {
            required: true,
            message: '请选择文化程度',
            trigger: 'change'
          }
        ],
        phone: [
          {
            required: true,
            message: '联系电话不能为空',
            trigger: 'blur'
          }
        ],
        account: [
          {
            required: true,
            message: '户籍区划不能为空',
            trigger: 'blur'
          }
        ],
        difftype: [
          {
            required: true,
            message: '请选择困难类型',
            trigger: 'change'
          }
        ],
        mincome: [
          {
            required: true,
            message: '月均收入不能为空',
            trigger: 'blur'
          }
        ],
        type: [
          {
            required: true,
            message: '请选择人员类型',
            trigger: 'change'
          }
        ],
        accounttype: [
          {
            required: true,
            message: '请选择户口性质',
            trigger: 'change'
          }
        ],
        cardno: [
          {
            required: true,
            message: '就业创业证号不能为空',
            trigger: 'blur'
          }
        ],
        untype: [
          {
            required: true,
            message: '请选择登记失业地类型',
            trigger: 'change'
          }
        ],
        untime: [
          {
            required: true,
            type: 'date',
            message: '请选择失业时间',
            trigger: 'change'
          }
        ],
        unregtime: [
          {
            required: true,
            type: 'date',
            message: '请选择失业登记时间',
            trigger: 'change'
          }
        ],
        unresult: [
          {
            required: true,
            message: '失业登记原因不能为空',
            trigger: 'blur'
          }
        ],
        accaddress: [
          {
            required: true,
            message: '户籍地址不能为空',
            trigger: 'blur'
          }
        ],
        nowaddress: [
          {
            required: true,
            message: '居住地址不能为空',
            trigger: 'blur'
          }
        ],
        getinsurance: [
          {
            required: true,
            message: '请选择是否申领失业保险金',
            trigger: 'change'
          }
        ],
        train1: [
          {
            required: true,
            message: '培训愿望1不能为空',
            trigger: 'blur'
          }
        ],
        train2: [
          {
            required: true,
            message: '培训愿望2不能为空',
            trigger: 'blur'
          }
        ],
        train3: [
          {
            required: true,
            message: '培训愿望3不能为空',
            trigger: 'blur'
          }
        ],
        state: [
          {
            required: true,
            message: '请选择状态',
            trigger: 'change'
          }
        ]
      },
      columns: [
        {
          type: 'selection',
          key: 'id',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        {
          title: '个人编号',
          key: 'perno',
          width: 120,
          fixed: 'left',
          align: 'center',
          sortable: true },
        {
          title: '姓名',
          key: 'pname',
          width: 120,
          fixed: 'left',
          align: 'center',
          sortable: true },
        {
          title: '性别',
          key: 'sex_CN',
          width: 120,
          fixed: 'left',
          align: 'center',
          sortable: true },
        {
          title: '身份证号',
          key: 'idcard',
          fixed: 'left',
          width: 180,
          align: 'center',
          sortable: true },
        {
          title: '文化程度',
          key: 'pedu_CN',
          width: 120,
          align: 'center',
          sortable: true },
        {
          title: '联系电话',
          key: 'phone',
          fixed: 'right',
          width: 120,
          align: 'center',
          sortable: true },
        {
          title: '户籍区划',
          key: 'account',
          width: 150,
          align: 'center',
          sortable: true },
        {
          title: '困难类型',
          key: 'difftype_CN',
          width: 120,
          align: 'center',
          sortable: true },
        {
          title: '月均收入',
          key: 'mincome',
          width: 120,
          align: 'center',
          sortable: true },
        {
          title: '人员类型',
          key: 'type_CN',
          fixed: 'right',
          width: 120,
          align: 'center',
          sortable: true },
        {
          title: '户口性质',
          key: 'accounttype_CN',
          width: 120,
          align: 'center',
          sortable: true },
        {
          title: '就业创业证号',
          key: 'cardno',
          width: 180,
          align: 'center',
          sortable: true },
        {
          title: '登记失业地类型',
          key: 'untype_CN',
          width: 150,
          align: 'center',
          sortable: true },
        {
          title: '失业时间',
          key: 'untime',
          width: 180,
          align: 'center',
          sortable: true },
        {
          title: '失业登记时间',
          key: 'unregtime',
          width: 180,
          align: 'center',
          sortable: true },
        {
          title: '失业登记原因',
          key: 'unresult',
          width: 120,
          align: 'center',
          sortable: true },
        {
          title: '户籍地址',
          key: 'accaddress',
          width: 120,
          align: 'center',
          sortable: true },
        {
          title: '居住地址',
          key: 'nowaddress',
          width: 120,
          align: 'center',
          sortable: true },
        {
          title: '是否申领失业保险金',
          key: 'getinsurance_CN',
          width: 120,
          align: 'center',
          sortable: true },
        {
          title: '培训愿望1',
          key: 'train1',
          width: 120,
          align: 'center',
          sortable: true },
        {
          title: '培训愿望2',
          key: 'train2',
          width: 120,
          align: 'center',
          sortable: true },
        {
          title: '培训愿望3',
          key: 'train3',
          width: 120,
          align: 'center',
          sortable: true },
        {
          title: '状态',
          key: 'state_CN',
          width: 120,
          align: 'center',
          sortable: true },
        {
          title: '操作',
          key: 'handle',
          fixed: 'right',
          width: 220,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.showonetoone(params.row.id)
                    }
                  }
                },
                '一人一档'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.editModal(params.row, 'post', '修改')
                    }
                  }
                },
                '编辑'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.delData(params)
                    }
                  }
                },
                '删除'
              )
            ])
          }
        }
      ]
    }
  },
  computed: {
    ...mapState({
      rules: state => state.user.rules
    })
  },
  methods: {
    getAssistpersonlist (key, value) {
      this.spinShow = true
      getAssistpersonlist(this.pageNum, this.pageSize, key, value).then(res => {
        if (res.data.code === 0) {
          this.pageTotal = res.data.count
          this.tableData = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
        this.spinShow = false
      })
    },
    getParameterList () {
      getsysparameterList('assist_person', 'sex').then(res => {
        if (res.data.code === 0) {
          this.sexList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('assist_person', 'pedu').then(res => {
        if (res.data.code === 0) {
          this.peduList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('assist_person', 'difftype').then(res => {
        if (res.data.code === 0) {
          this.difftypeList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('assist_person', 'employmenttype').then(res => {
        if (res.data.code === 0) {
          this.employmenttypeList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })

      getsysparameterList('assist_person', 'type').then(res => {
        if (res.data.code === 0) {
          this.typeList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('assist_person', 'accounttype').then(res => {
        if (res.data.code === 0) {
          this.accounttypeList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('assist_person', 'untype').then(res => {
        if (res.data.code === 0) {
          this.untypeList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('assist_person', 'getinsurance').then(res => {
        if (res.data.code === 0) {
          this.getinsuranceList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('assist_person', 'state').then(res => {
        if (res.data.code === 0) {
          this.stateList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    },
    handleSelectChange (val) {
      let SelectIdList = []
      val.forEach(item => {
        SelectIdList.push(item.id)
      })
      this.tableSelectIdList = SelectIdList
    },
    closeModal () {
      this.dialog.show = false
    },
    inttostr (int) {
      if (int != null) {
        return int.toString()
      } else {
        return ''
      }
    },
    showonetoone(id){
      this.onetoneVisble = true
      this.onerowid = id
    },
    editModal (paramsRow, meth, mtitle) {
      this.modalMap.modalVisible = true
      this.modalMap.modalTitle = mtitle
      this.editModalData = meth
      // this.getParameterList();
      var day2 = new Date()
      day2.setTime(day2.getTime())
      var s2 = day2.getFullYear() + '-' + (day2.getMonth() + 1) + '-' + day2.getDate() + ' ' + day2.getHours() + ':' + day2.getMinutes() + ':' + day2.getSeconds()
      if (paramsRow && paramsRow.id) {
        this.formValidate = {
          id: paramsRow.id,
          perno: paramsRow.perno,
          pname: paramsRow.pname,
          sex: this.inttostr(paramsRow.sex),
          idcard: paramsRow.idcard,
          pedu: this.inttostr(paramsRow.pedu),
          phone: paramsRow.phone,
          account: paramsRow.account,
          difftype: this.inttostr(paramsRow.difftype),
          mincome: paramsRow.mincome,
          type: this.inttostr(paramsRow.type),
          accounttype: this.inttostr(paramsRow.accounttype),
          cardno: paramsRow.cardno,
          untype: this.inttostr(paramsRow.untype),
          untime: paramsRow.untime,
          unregtime: paramsRow.unregtime,
          unresult: paramsRow.unresult,
          accaddress: paramsRow.accaddress,
          nowaddress: paramsRow.nowaddress,
          getinsurance: this.inttostr(paramsRow.getinsurance),
          train1: paramsRow.train1,
          train2: paramsRow.train2,
          train3: paramsRow.train3,
          state: this.inttostr(paramsRow.state)
        }
      } else {
        this.formValidate = {
          id: 0,
          perno: '',
          pname: '',
          sex: '',
          idcard: '',
          pedu: '',
          phone: '',
          account: '',
          difftype: '',
          mincome: '',
          type: '',
          accounttype: '',
          cardno: '',
          untype: '',
          untime: s2,
          unregtime: s2,
          unresult: '',
          accaddress: '',
          nowaddress: '',
          getinsurance: '',
          train1: '',
          train2: '',
          train3: '',
          state: ''
        }
      }
    },
    handleSubmit (value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            this.formValidate.untime = moment(this.formValidate.untime).utcOffset(480).format('YYYY-MM-DD HH:mm:ss')
            this.formValidate.unregtime = moment(this.formValidate.unregtime).utcOffset(480).format('YYYY-MM-DD HH:mm:ss')
            operationAssistperson(this.formValidate, this.editModalData).then(res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                if (this.searchVal) {
                  this.getAssistpersonlist(this.searchVal)
                } else {
                  this.getAssistpersonlist()
                }
                this.modalMap.modalVisible = false
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
          }, 1000)
        } else {
          this.$Message.error('缺少必要参数')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    },
    handlerDelete () {
      if (this.tableSelectIdList.length > 0) {
        if (confirm(`确定要批量删除选中数据嘛？ `)) {
          operationAssistperson({'id_list': this.tableSelectIdList}, 'delete').then(res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                this.getAssistpersonlist(this.searchVal)
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
        }
      } else {
        this.$Message.info(`你总要选中点什么吧`)
      }
    },
    delData (params) {
      if (confirm(`确定要删除该信息吗？`)) {
        operationAssistperson(
          {
            'id': params.row.id
          },
          'delete'
        ).then(res => {
          if (res.data.code === 0) {
            this.$Message.success(`${res.data.msg}`)
            this.tableData.splice(params.index, 1)
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      }
    },
    changePage (value) {
      this.pageNum = value
      if (this.searchVal) {
        this.getAssistpersonlist(this.searchVal)
      } else {
        this.getAssistpersonlist()
      }
    },
    handlePageSize (value) {
      this.pageSize = value
      this.pageNum = 1
      if (this.searchVal) {
        this.getAssistpersonlist(this.searchVal)
      } else {
        this.getAssistpersonlist()
      }
    },
    searchinput () {
      if (this.searchVal) {
        this.getAssistpersonlist(this.searchVal)
      } else {
        this.getAssistpersonlist()
      }
    },
    handleRemove () {
      this.showProgress = false
      this.showre = false
      this.initUpload()
      this.$Message.info('上传的文件已删除！')
    },
    connectWebSocket() {
      // 在这里传递参数
      this.ws = new WebSocket('wss://ljtc.tcrc.com.cn/m_ws/assistperson/importws/');

      this.ws.onmessage = (event) => {
        console.log("收到消息：", event.data);
        let json = JSON.parse(event.data);
        if (json.code == 1) {
          this.inprogress = json.percent
        }
        else if (json.code == 0){
          this.$Message.success(`${json.msg}`)
          this.showre = true
          this.inprogress = json.percent
          this.showretxt = json.msg
          this.uploadLoading = false
          this.getAssistpersonlist(this.searchVal)
        }else{
          this.$Message.error(`${json.msg}`)
        }
      };

      this.ws.onclose = () => {
        console.log('WebSocket closed');
      };
    },
    sendMessage(message) {
      if (this.ws.readyState === WebSocket.OPEN) {
        this.ws.send(JSON.stringify(message));
      } else {
        console.log("WebSocket 连接未打开");
      }
    },
    handlerimport () {
      if (this.tableDatatmp.length > 0) {
        this.uploadLoading = true


        this.sendMessage({'data_list': this.tableDatatmp, 'filename': this.file.name})
        // importexceldata({'data_list': this.tableDatatmp, 'filename': this.file.name}, 'post').then(
        //   res => {
        //     this.progressPercent = 101
        //     if (res.data.code === 0) {
        //       this.$Message.success(`${res.data.msg}`)
        //       this.showre = true
        //       this.showretxt = res.data.msg
        //       this.uploadLoading = false
        //       this.getAssistpersonlist(this.searchVal)
        //     } else {
        //       this.$Message.error(`${res.data.msg}`)
        //     }
        //   })
        this.uploadLoading = false
      }
    },
    handlerimportold () {
      if (this.tableDatatmp.length > 0) {
        this.uploadLoading = true
        importexceldata({'data_list': this.tableDatatmp, 'filename': this.file.name}, 'post').then(
          res => {
            this.progressPercent = 101
            if (res.data.code === 0) {
              this.$Message.success(`${res.data.msg}`)
              this.showre = true
              this.showretxt = res.data.msg
              this.uploadLoading = false
              this.getAssistpersonlist(this.searchVal)
            } else {
              this.$Message.error(`${res.data.msg}`)
            }
          })
        this.uploadLoading = false
      }
    },
    readFile (file) {
      const reader = new FileReader()
      reader.readAsArrayBuffer(file)
      reader.onloadstart = e => {
        this.uploadLoading = true
        this.tableLoading = true
        this.showProgress = true
      }
      reader.onprogress = e => {
        this.progressPercent = Math.round(e.loaded / e.total * 100)
      }
      reader.onerror = e => {
        this.$Message.error('文件读取出错')
      }
      reader.onload = e => {
        this.$Message.info('文件读取成功')
        this.progressPercent = 100
        const data = e.target.result
        const {header, results} = excel.read(data, 'array')
        const tableTitle = header.map(item => {
          return {title: item, key: item}
        })
        this.tableDatatmp = results
        this.tableTitle = tableTitle
        this.uploadLoading = false
        this.tableLoading = false
        this.showRemoveFile = true
        // this.showProgress = false
      }
    },
    handleBeforeUpload (file) {
      const fileExt = file.name.split('.').pop().toLocaleLowerCase()
      if (fileExt === 'xlsx' || fileExt === 'xls') {
        this.readFile(file)
        this.uploadLoading = true
        this.tableLoading = true
        this.showProgress = true
        this.file = file
      } else {
        this.$Notice.warning({
          title: '文件类型错误',
          desc: '文件：' + file.name + '不是EXCEL文件，请选择后缀为.xlsx或者.xls的EXCEL文件。'
        })
      }
      return false
    },
    handleUploadFile () {
      this.initUpload()
    },
    initUpload () {
      this.file = null
      this.showProgress = false
      this.loadingProgress = 0
      this.tableDatatmp = []
      this.tableTitle = []
      this.connectWebSocket()
    }
  },
  watch: {
    searchVal (val) {
      this.searchVal = val
    }
  },
  mounted () {
    this.getAssistpersonlist()
    this.getParameterList()
  }
}
</script>
<style lang="less" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  //background-color: #f9fafc;
}
.search-con {
  padding: 10px 0;
  .search {
    &-col {
      display: inline-block;
      width: 200px;
    }
    &-input {
      display: inline-block;
     width: 200px;
      margin-left: 2px;
    }
    &-btn {
      margin-left: 2px;
    }
  }
}
</style>
